import { useState } from "react";
import {
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Legend,
} from "recharts";
import { sortFromFabricChart, sortFromFabricChartByDays } from "../../util/sortCart";

export const ChartFabric = ({ chart }) => {
  const [selectedMonth, setSelectedMonth] = useState(null);

  const monthlyData = chart && chart.length !== 0 ? sortFromFabricChart(chart) : [];
  const dailyData = selectedMonth 
    ? sortFromFabricChartByDays(chart, selectedMonth.year, selectedMonth.month)
    : [];

  function handleBarClick(data) {
    if (data && data.activePayload && data.activePayload[0]) {
      const clickedData = data.activePayload[0].payload;
      if (clickedData.year && clickedData.month) {
        setSelectedMonth({ year: clickedData.year, month: clickedData.month });
      }
    }
  }

  function handleBackToMonths() {
    setSelectedMonth(null);
  }

  const displayData = selectedMonth ? dailyData : monthlyData;
  const chartTitle = selectedMonth 
    ? `${selectedMonth.month < 10 ? '0' + selectedMonth.month : selectedMonth.month}.${selectedMonth.year}` 
    : 'By Months';

  return (
    <div className="w-[99%] m-auto pb-2 ">
      <div className="flex justify-between items-center px-4 mt-2">
        <h3 className="text-[#739D00] font-semibold">{chartTitle}</h3>
        {selectedMonth && (
          <button 
            onClick={handleBackToMonths}
            className="px-4 py-1 bg-[#739D00] text-white rounded hover:bg-[#5a7d00] transition"
          >
            Back to Months
          </button>
        )}
      </div>
      <div className=" h-[300px] m-auto mt-[20px]">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={displayData}
            margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
            onClick={!selectedMonth ? handleBarClick : undefined}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
            <XAxis 
              dataKey="name" 
              stroke="#9E9E9E"
              style={{ fontSize: '14px', fontFamily: 'Rubik' }}
            />
            <YAxis 
              stroke="#9E9E9E"
              style={{ fontSize: '14px', fontFamily: 'Rubik' }}
            />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: '#fff', 
                border: '2px solid #739D00',
                borderRadius: '8px',
                fontFamily: 'Rubik'
              }}
            />
            <Legend 
              wrapperStyle={{ fontFamily: 'Rubik' }}
            />
            <Bar 
              dataKey="metrs" 
              fill="#739D00" 
              radius={[8, 8, 0, 0]}
              name="Metrs"
              cursor={!selectedMonth ? 'pointer' : 'default'}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
